"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 38.4 24",
    width: "38.4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 3.2h-2.4a.82.82 0 0 0 -.72.44l-2.4 4.8a.82.82 0 0 0 .36 1.08.94.94 0 0 0 .36.08.81.81 0 0 0 .72-.44l2.17-4.36h1.91a.8.8 0 0 0 0-1.6z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m37.6 11.2h-10.38v1.6h9.58v3.2h-20.8v-3.2h4v-1.6h-4v-10.4a.8.8 0 0 0 -.8-.8h-7.2a.81.81 0 0 0 -.7.41l-3.95 7.1-3.12 3.12a.81.81 0 0 0 -.23.57v8.8a.8.8 0 0 0 .8.8h3.28a4 4 0 0 0 7.84 0h14.56a4 4 0 0 0 7.84 0h3.28a.8.8 0 0 0 .8-.8v-8a.8.8 0 0 0 -.8-.8zm-33.52 8h-2.48v-1.6h3.22a4 4 0 0 0 -.74 1.6zm3.92 3.2a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm-6.4-6.4v-4.47l3-3 .13-.18 3.74-6.75h5.93v14.4zm24.88 3.2h-14.56a4 4 0 0 0 -.74-1.6h16a4 4 0 0 0 -.7 1.6zm3.92 3.2a2.4 2.4 0 1 1 2.4-2.4 2.41 2.41 0 0 1 -2.4 2.4zm6.4-3.2h-2.48a4 4 0 0 0 -.74-1.6h3.22z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.84 13.07v-10.95l9.12 5.48z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;